export enum HighLevelPlaqueTypeEnum
{
    Tag = 80,
    Card = 81,
    Dedication = 82,
    Board = 83
}